import {ChangeDetectionStrategy, Component, computed, inject, Input, OnInit, Signal} from '@angular/core';
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonMenuButton,
  IonNavLink,
  IonProgressBar,
  IonTitle,
  IonToolbar,
  Platform
} from "@ionic/angular/standalone";
import {Router, RouterLink, RouterLinkActive} from "@angular/router";
import {ApiService, AuthService} from "@app/services";
import {User} from "@app/interfaces";
import {addIcons} from "ionicons";
import {personOutline, searchOutline} from "ionicons/icons";
import {SettingsService} from "@services/api/settings.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButton,
    IonButtons,
    IonBackButton,
    RouterLink,
    IonProgressBar,
    IonNavLink,
    RouterLinkActive,
    IonMenuButton,
    IonIcon,
  ]
})
export class HeaderComponent implements OnInit {

  @Input({required: true}) public title: string | undefined = '';
  @Input() public hideSearchButton = false;

  public showProgressBar: Signal<boolean> = computed(() => this.apiService.isLoading());
  public isMobile: boolean = false;
  public user: Signal<User | null> = computed(() => this.authService.currentUser());

  public settingsService: SettingsService = inject(SettingsService);

  canGoBack = false;

  protected readonly location = location;

  private platform: Platform = inject(Platform);
  private authService = inject(AuthService);
  private apiService = inject(ApiService);
  private router: Router = inject(Router);

  constructor() {
    this.isMobile = this.platform.is('mobile');
    console.log('HeaderComponent.constructor', location.pathname);
    addIcons({searchOutline, personOutline});
  }

  ngOnInit() {
    console.log('HeaderComponent.ngOnInit');
    this.canGoBack = this.router.getCurrentNavigation()?.previousNavigation !== null;
  }
}
